import { useConnect } from '@lore/query-connect';
import REQUIRED_FIELDS_PAST from '../projects/REQUIRED_FIELDS_PAST';

export default function usePastProjectsForUser(user, options = {}) {
  return useConnect('project.find', {
    where: {
      eager: {
        $where: {
          creatorId: user.id,
          $and: REQUIRED_FIELDS_PAST.$and
        }
      }
    },
    pagination: {
        page: options.page || 1,
        pageSize: options.pageSize || 3,
        order: 'createdAt desc'
      }
    });
  }
